/* God Console — nav model (6 groups, 13 sections). */
export type GodNavItem = { id: string; label: string; icon: string; count?: string | number };
export type GodNavGroup = { group: string; items: GodNavItem[] };

export const GOD_NAV: GodNavGroup[] = [
  { group: "Overview", items: [{ id: "dash", label: "God Dashboard", icon: "radar" }] },
  {
    group: "People",
    items: [
      { id: "users", label: "Users", icon: "users" },
      { id: "orgs", label: "Organizations", icon: "building-2" },
    ],
  },
  {
    group: "Money",
    items: [
      { id: "revenue", label: "Billing & Revenue", icon: "banknote" },
      { id: "cost", label: "Cost & Margin", icon: "receipt-text" },
    ],
  },
  {
    group: "Product",
    items: [
      { id: "curriculum", label: "Curriculum & Prompts", icon: "file-code-2" },
      { id: "ai", label: "AI & Voice config", icon: "cpu" },
      { id: "memory", label: "Memory Inspector", icon: "brain-circuit" },
    ],
  },
  {
    group: "Platform",
    items: [
      { id: "observability", label: "Observability", icon: "activity" },
      { id: "releases", label: "Releases", icon: "package" },
      { id: "flags", label: "Feature Flags", icon: "flag" },
    ],
  },
  {
    group: "Trust",
    items: [
      { id: "comms", label: "Comms", icon: "megaphone" },
      { id: "audit", label: "Safety & Audit", icon: "shield-alert" },
    ],
  },
];

export const GOD_CRUMB: Record<string, [string, string]> = {
  dash: ["Overview", "God Dashboard"],
  users: ["People", "Users"],
  orgs: ["People", "Organizations"],
  revenue: ["Money", "Billing & Revenue"],
  cost: ["Money", "Cost & Margin"],
  curriculum: ["Product", "Curriculum & Prompts"],
  ai: ["Product", "AI & Voice config"],
  memory: ["Product", "Memory Inspector"],
  observability: ["Platform", "Observability"],
  releases: ["Platform", "Releases"],
  flags: ["Platform", "Feature Flags"],
  comms: ["Trust", "Comms"],
  audit: ["Trust", "Safety & Audit"],
};

export const OPERATOR = { name: "You", initials: "OP", email: "ops@adaptr.ai", role: "super_admin" };
